module.exports = __webpack_public_path__ + "img/DE03625.e8e065a9.png";